import { FC } from "react";
import image from "../../Assets/TalentOnDemand/tech-hero.png";
import bgImage from "../../Assets/homev2/el-bg.png";

const TalentOnDemandTechHero: FC = () => {
    return (
        <section
            className="w-full bg-cover bg-no-repeat bg-bottom overflow-hidden max-h-[911px] relative"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full max-w-[1400px] mx-auto px-2 md:pl-12 flex flex-col lg:flex-col text-center items-center justify-between gap-10 pt-16">

                {/* LEFT: Text */}
                <div className="max-w-[1400px] text-center lg:text-center">
                    <h1 className="text-4xl md:text-5xl font-semibold text-black leading-tight mb-6">
                        Tech Industry Experts <br className="hidden lg:block" />
                        For Your Team
                    </h1>
                    <p className="text-lg text-gray-800 mb-8">
                        Salesmrkt specializes in placing the top developers, software engineers, and<br /> executive talent in hard to fill roles or in <em>“we need to fill right now”</em> situations.
                    </p>
                    <a
                        target="_blank"
                        href={"https://calendly.com/salesbox-meet/talent-ondemand-package"}
                        className="bg-brand-green hover:bg-transparent hover:text-black border border-brand-green hover:border-black text-white font-medium px-6 py-3 rounded-full transition-all duration-200"
                    >
                        Learn More
                    </a>
                </div>

                {/* RIGHT: Image */}
                <img
                    src={image}
                    alt="Tech Experts Hero"
                    className="w-full h-full object-contain max-w-[700px]"
                />
            </div>
        </section>
    );
};

export default TalentOnDemandTechHero;
